/* PRACTICTECH — finition v3 (brouillon)
 * Titres révélés mot à mot, compteurs, onde au toucher, vignette qui vole vers
 * le panier, galerie (image active), léger mouvement du hero à la souris.
 * Aucune dépendance ; tout est ignoré si l'utilisateur préfère moins d'animations.
 */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canIO = 'IntersectionObserver' in window;
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[pt3]', e); } }

  /* 1. Titres : découpage en mots (l'apparition est déclenchée par .is-in) */
  function splitTitles() {
    if (reduce) return;
    document.querySelectorAll('.pt-h2[data-pt-reveal], .pt-final__title[data-pt-reveal]').forEach(function (h) {
      if (h.hasAttribute('data-pt-split') || h.children.length) return;
      var words = h.textContent.trim().split(/\s+/);
      h.setAttribute('aria-label', h.textContent.trim());
      h.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'pt-w'; s.setAttribute('aria-hidden', 'true');
        s.style.setProperty('--wi', i);
        s.textContent = w;
        h.appendChild(s);
        if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
      });
      h.setAttribute('data-pt-split', '');
    });
  }

  /* 2. Compteurs (uniquement des chiffres réels, de 0 à la valeur) */
  function counters() {
    var els = document.querySelectorAll('[data-pt-count]');
    if (!els.length || reduce || !canIO) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, to = parseInt(el.getAttribute('data-pt-count'), 10) || 0;
        if (to <= 0) return;
        var t0 = performance.now(), dur = 900 + to * 40;
        (function step(t) {
          var k = Math.min(1, (t - t0) / dur);
          k = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(to * k);
          if (k < 1) requestAnimationFrame(step); else el.textContent = to;
        })(t0);
        el.textContent = '0';
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 3. Onde au toucher + reflet des cartes */
  function ripples() {
    if (reduce) return;
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('.pt-btn');
      if (!b || b.disabled) return;
      var r = b.getBoundingClientRect(), d = Math.max(r.width, r.height) * 2.2;
      var s = document.createElement('span');
      s.className = 'pt-ripple';
      s.style.cssText = 'width:' + d + 'px;height:' + d + 'px;left:' + (e.clientX - r.left - d / 2) + 'px;top:' + (e.clientY - r.top - d / 2) + 'px';
      b.appendChild(s);
      setTimeout(function () { s.remove(); }, 700);
    }, { passive: true });
    document.addEventListener('pointermove', function (e) {
      var c = e.target.closest && e.target.closest('.pt-card');
      if (!c) return;
      var r = c.getBoundingClientRect();
      c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      c.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* 4. Ajout au panier : la vignette du bracelet vole jusqu'à l'icône panier */
  function cartTarget() {
    var sel = ['.header-actions__cart-icon', 'cart-icon', '[data-testid="cart-drawer-trigger"]', 'a[href$="/cart"]', 'button[aria-controls*="cart"]'];
    for (var i = 0; i < sel.length; i++) {
      var list = document.querySelectorAll(sel[i]);
      for (var j = 0; j < list.length; j++) { var r = list[j].getBoundingClientRect(); if (r.width && r.top < window.innerHeight) return list[j]; }
    }
    return null;
  }
  function fly(fromEl) {
    if (reduce || !fromEl || !Element.prototype.animate) return;
    var src = document.querySelector('.pt-gal__slide img, .pt-sticky__thumb img');
    var target = cartTarget();
    var a = fromEl.getBoundingClientRect();
    var b = target ? target.getBoundingClientRect() : { left: window.innerWidth - 40, top: 16, width: 24, height: 24 };
    var f = document.createElement('div');
    f.className = 'pt-fly';
    if (src) { var im = document.createElement('img'); im.src = src.currentSrc || src.src; im.alt = ''; f.appendChild(im); }
    var x0 = a.left + a.width / 2 - 32, y0 = a.top + a.height / 2 - 32;
    var x1 = b.left + b.width / 2 - 32, y1 = b.top + b.height / 2 - 32;
    f.style.left = x0 + 'px'; f.style.top = y0 + 'px';
    document.body.appendChild(f);
    var dx = x1 - x0, dy = y1 - y0;
    f.animate([
      { transform: 'translate(0,0) scale(0.6)', opacity: 0 },
      { transform: 'translate(' + dx * 0.25 + 'px,' + (dy * 0.25 - 60) + 'px) scale(1)', opacity: 1, offset: 0.3 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.25)', opacity: 0.2 }
    ], { duration: 820, easing: 'cubic-bezier(0.5, 0, 0.2, 1)' }).onfinish = function () {
      f.remove();
      if (target) { target.classList.remove('pt-bump'); void target.offsetWidth; target.classList.add('pt-bump'); }
    };
  }
  function watchAdds() {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('[data-pt-add], [data-pt-sticky-add]').forEach(function (btn) {
      new MutationObserver(function (m) {
        m.forEach(function (r) { if (r.attributeName === 'data-state' && btn.getAttribute('data-state') === 'added') fly(btn); });
      }).observe(btn, { attributes: true, attributeFilter: ['data-state'] });
    });
  }

  /* 5. Galerie : l'image au centre est nette, les autres légèrement en retrait */
  function galleryFocus() {
    document.querySelectorAll('[data-pt-gal-track]').forEach(function (track) {
      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;
      slides[0].classList.add('is-cur');
      if (!canIO) { slides.forEach(function (s) { s.classList.add('is-cur'); }); return; }
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { e.target.classList.toggle('is-cur', e.intersectionRatio > 0.55); });
      }, { root: track, threshold: [0, 0.55, 1] });
      slides.forEach(function (s) { io.observe(s); });
    });
  }

  /* 6. Hero ordinateur : le produit suit très légèrement la souris */
  function heroParallax() {
    if (reduce || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    var hero = document.querySelector('.pt-hero'), fl = hero && hero.querySelector('.pt-hero__float');
    if (!fl) return;
    var raf = 0, mx = 0, my = 0;
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - 0.5; my = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; fl.style.setProperty('--hx', (mx * -14).toFixed(1) + 'px'); fl.style.setProperty('--hy', (my * -10).toFixed(1) + 'px'); });
    }, { passive: true });
    hero.addEventListener('pointerleave', function () { fl.style.setProperty('--hx', '0px'); fl.style.setProperty('--hy', '0px'); });
  }


  /* 7. Couleur choisie : la 1re photo de la galerie montre le bracelet de cette couleur */
  function colorImages() {
    document.querySelectorAll('[data-pt-buy]').forEach(function (box) {
      var el = box.querySelector('script[data-pt-color-images]');
      if (!el) return;
      var map; try { map = JSON.parse(el.textContent); } catch (e) { return; }
      var track = box.querySelector('[data-pt-gal-track]');
      var img = track && track.querySelector('.pt-gal__slide img');
      if (!img) return;
      var thumb = box.querySelector('[data-pt-gal-go="0"] img');
      var sticky = document.querySelector('.pt-sticky__thumb img');
      var current = null;
      function apply(label, instant) {
        var d = map[label];
        if (!d || label === current) return;
        current = label;
        var pre = new Image();
        pre.sizes = img.sizes || '100vw';
        pre.srcset = d.srcset; pre.src = d.src;
        function swap() {
          img.srcset = d.srcset; img.src = d.src;
          if (thumb) { thumb.removeAttribute('srcset'); thumb.src = d.thumb; }
          if (sticky) { sticky.removeAttribute('srcset'); sticky.src = d.thumb; }
          img.classList.remove('pt-swap-out');
        }
        if (instant || reduce) { swap(); return; }
        if (track.scrollLeft > 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        img.classList.add('pt-swap-out');
        var done = false;
        function go() { if (done) return; done = true; setTimeout(swap, 180); }
        if (pre.decode) pre.decode().then(go, go); else pre.onload = go;
        setTimeout(go, 1200);
      }
      document.addEventListener('pt:variant', function (e) { if (e.detail && e.detail.label) apply(e.detail.label); });
      var checked = box.querySelector('.pt-swatch input:checked + label span');
      if (checked) apply(checked.textContent.trim(), true);
    });
  }

  function boot() { safe(splitTitles); safe(counters); safe(ripples); safe(watchAdds); safe(galleryFocus); safe(heroParallax); safe(colorImages); }
  // splitTitles doit passer avant que pt-premium.js n'ajoute .is-in aux titres déjà visibles
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { safe(splitTitles); safe(counters); safe(galleryFocus); });
})();
